import {
  IB_PREPARE_CONNECT_GWT,
  IB_CONNECT_GWT_SUCCESS,
  IB_GWT_INTEGRATION_SOLVED,
  IB_GWT_INTEGRATION_FAIL_SOLVE,
  IB_SAVE_INTEGRATION_FAILURE,
  IB_RESET,
} from '../../actions/integrationBuilder';

export const INITIAL_STATE = {
  prepareConnectGwt: false,
  gwtIntegrationIdSolved: false,
};

export default function gwtStateReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case IB_PREPARE_CONNECT_GWT: {
      return {
        ...state,
        prepareConnectGwt: true,
      };
    }
    case IB_GWT_INTEGRATION_SOLVED: {
      return {
        ...state,
        gwtIntegrationIdSolved: true,
      };
    }
    case IB_CONNECT_GWT_SUCCESS:
    case IB_RESET:
    case IB_GWT_INTEGRATION_FAIL_SOLVE:
    case IB_SAVE_INTEGRATION_FAILURE: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
}
